import { ReportQueryDocument } from "@pathwright/graphql-client/src/generated"

export default ReportQueryDocument
